import PeregrineContextProvider from "@/PeregrineContextProvider"
import {
  WindowSizeContextProvider 
} from "@/common/hooks/useWindowSize"
import {
  ToastContextProvider 
} from "@/hooks/Toasts"
import LocaleProvider from "./localeProvider"

const contextProviders = [
  LocaleProvider,
  PeregrineContextProvider,
  WindowSizeContextProvider,
  ToastContextProvider,
]

const ContextProvider = ({
  children 
}) => {
  return contextProviders.reduceRight((memo, ContextProvider) => {
    return <ContextProvider>{memo}</ContextProvider>
  }, children)
}

export default ContextProvider
